// extracted by mini-css-extract-plugin
export default {"game-wrap":"c3zus5Dgn50PA4JMghK7","game-img":"xAnbXBAGxm6SZmytMRsA","game-content-wrap":"W96uqRDAegtzcRtcfWZN","btn-group":"iPcVTZbcBfmu0wfNcn0w","learn-more":"SZxFNJzbLO8VtRqqTyfw"};